module.exports = __webpack_public_path__ + "static/media/hr.176d2d57.svg";